import { VersicherungssummeForLinie } from '../action-types/versicherungssummenResponseReceived';

export interface StatePreV9 {
  version: number;
  versicherungssummen?: VersSummenPreV9[];
  versicherungssummeFahrrad?: FahrradVersSummenPreV9[];
  wertsachensummen?: WertsachenSummenPreV9[];
}

export interface VersSummenPreV9 {
  produktlinie: Produktline;
  summe: number;
}

export interface FahrradVersSummenPreV9 {
  produktlinie: Produktline;
  summe: FahrradWert;
}

export interface WertsachenSummenPreV9 {
  produktline: Produktline;
  summe: number;
  minSumme: number;
  maxSumme: number;
  editable: boolean;
}

export enum Produktline {
  S = 'S',
  M = 'M',
  L = 'L',
  XL = 'XL',
}

export enum Produktlinienname {
  BASIS = 'BASIS',
  SMART = 'SMART',
  KOMFORT = 'KOMFORT',
  PREMIUM = 'PREMIUM',
}

export interface StateV9 {
  version: number;
  versicherungssummen: VersicherungssummeForLinie[];
  versicherungssummeFahrrad: FahradwertForLinie[];
  wertsachensummen: Wertsachensumme[];
}

export interface FahradwertForLinie {
  produktlinie: Produktlinienname;
  summe: FahrradWert;
}

export enum FahrradWert {
  BIS1500 = 'BIS1500',
  BIS3000 = 'BIS3000',
  BIS6000 = 'BIS6000',
  UEBER6000 = 'UEBER6000',
}

export interface Wertsachensumme {
  produktline: Produktlinienname;
  summe: number;
  minSumme: number;
  maxSumme: number;
  editable: boolean;
}
